import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BASE_URL } from './http.service';
import { httpOptions } from './http.util';

/**
 * Fetches help document metadata from the API. Does not use the shared
 * HTTP error handler so a missing document does not trigger global side effects
 * (e.g. redirect to /notfound).
 */
@Injectable({
  providedIn: 'root',
})
export class HelpDocumentsService {
  constructor(private http: HttpClient) {}

  getPdfUrl(slug: string): Observable<string | null> {
    const url = `${BASE_URL}/help_documents/${encodeURIComponent(slug)}`;
    return this.http
      .get<unknown>(url, {
        ...httpOptions({
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }),
      })
      .pipe(
      map((response) => extractPdfUrl(response)),
      catchError((err) => {
        console.error('Failed to load help document', slug, err);
        return of(null);
      })
    );
  }
}

function extractPdfUrl(response: unknown): string | null {
  if (!response || typeof response !== 'object') {
    return null;
  }
  const data = (response as { data?: unknown }).data;
  if (!data || typeof data !== 'object') {
    return null;
  }
  const pdfUrl = (data as { pdf_url?: unknown }).pdf_url;
  return typeof pdfUrl === 'string' && pdfUrl.length > 0 ? pdfUrl : null;
}
